import 'youtube-video-js';

document.addEventListener('DOMContentLoaded', function () {
	let $figVideo = document.querySelectorAll('figure.media');
	if ($figVideo.length) {
		for (let $element of $figVideo) {
			let $oembed = $element.querySelector('oembed');

			if ($oembed) {
				let getVideo = $oembed.getAttribute('url');

				if (getVideo) {
					let video = document.createElement('youtube-video');
					video.setAttribute('src', getVideo);
					video.setAttribute('controls', '');
					video.setAttribute('autoplay', '');

					$element.append(video);

					video.load().then(() => {
						const timer = setTimeout(function () {
							video.pause();

							let iframe = video.querySelector('iframe');
							if (iframe) {
								iframe.height = iframe.clientWidth * 55.8 / 100;

								window.addEventListener('resize', function () {
									iframe.height = iframe.clientWidth * 55.8 / 100;
								});
							}

							clearTimeout(timer);
						}, 1000);
					});
				} else {
					$element.remove();
				}
			}

			$oembed.remove();
		}
	}
});
